/* Recover only the confirmed desktop signup form after a completed, stranded fade-out. */
(() => {
  'use strict';
  const modalSelector = '[role="dialog"][aria-label="POPUP Form"][data-kl-scroll-locking-modal="true"]';
  const formSelector = 'form[data-testid="klaviyo-form-R5dnsk"]';
  const marker = 'data-whipi-dismissed-popup';
  const pending = new WeakMap();
  const originalInert = new WeakMap();
  let lastOutsideFocus = null;
  let queued = false;

  const isTarget = (node) => node.matches(modalSelector) && Boolean(node.querySelector(formSelector));
  const isFadeOut = (node) => getComputedStyle(node).animationName.split(',').some((name) => name.trim() === 'klaviyo-fadeout');
  const durationMs = (value) => Math.max(0, ...value.split(',').map((part) => parseFloat(part) * (part.trim().endsWith('ms') ? 1 : 1000) || 0));

  function restore(node) {
    if (!node.hasAttribute(marker)) return;
    node.removeAttribute(marker);
    if (originalInert.get(node) === false) node.removeAttribute('inert');
    originalInert.delete(node);
  }

  function finishClose(node) {
    pending.delete(node);
    if (!node.isConnected || !isTarget(node) || !isFadeOut(node)) return;
    const style = getComputedStyle(node);
    if (style.display === 'none' || Number(style.opacity) > 0.01) return;
    if (!node.hasAttribute(marker)) {
      originalInert.set(node, node.hasAttribute('inert'));
      const focusWasInside = node.contains(document.activeElement);
      node.setAttribute(marker, 'true');
      node.setAttribute('inert', '');
      if (focusWasInside) {
        if (lastOutsideFocus?.isConnected && !node.contains(lastOutsideFocus)) lastOutsideFocus.focus({ preventScroll: true });
        else if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
      }
    }
    // Release only Klaviyo's own scroll-lock class, and only when no other form is open.
    const anotherOpen = [...document.querySelectorAll('[role="dialog"][data-kl-scroll-locking-modal="true"]')].some((other) => {
      if (other === node || other.hasAttribute(marker)) return false;
      const otherStyle = getComputedStyle(other);
      return otherStyle.display !== 'none' && otherStyle.visibility !== 'hidden';
    });
    if (!anotherOpen) document.body.classList.remove('klaviyo-prevent-body-scrolling');
  }

  function scan() {
    queued = false;
    document.querySelectorAll(modalSelector).forEach((node) => {
      if (!isTarget(node)) return;
      if (!isFadeOut(node)) {
        clearTimeout(pending.get(node));
        pending.delete(node);
        restore(node);
        return;
      }
      if (node.hasAttribute(marker) || pending.has(node) || getComputedStyle(node).display === 'none') return;
      const style = getComputedStyle(node);
      const wait = Math.max(600, durationMs(style.animationDuration) + durationMs(style.animationDelay) + 200);
      pending.set(node, setTimeout(() => finishClose(node), wait));
    });
  }

  function queueScan() {
    if (queued) return;
    queued = true;
    setTimeout(scan, 0);
  }

  document.addEventListener('focusin', (event) => {
    if (event.target instanceof HTMLElement && !event.target.closest(modalSelector)) lastOutsideFocus = event.target;
  });
  document.addEventListener('animationend', (event) => {
    if (event.animationName === 'klaviyo-fadeout' && event.target instanceof HTMLElement && isTarget(event.target)) queueScan();
  });
  new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  scan();
})();
